function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
var _require = require('./manual-block-production'),
  allowsManualTestingOnServer = _require.allowsManualTestingOnServer,
  EXPLORER_PRODUCE_BLOCK_REQUEST = _require.EXPLORER_PRODUCE_BLOCK_REQUEST,
  EXPLORER_PRODUCE_BLOCK_WITH_GT_REQUEST = _require.EXPLORER_PRODUCE_BLOCK_WITH_GT_REQUEST;
var _require2 = require('./peer/response'),
  success = _require2.success,
  failure = _require2.failure;
var _require3 = require('./manual-production-log'),
  logManualProduction = _require3.logManualProduction,
  logManualProductionError = _require3.logManualProductionError;

/**
 * Explorer manual-simulation test mode.
 * Server-owned state: set once per process lifetime; no exit until Explorer restarts.
 */

function disableTimerProductionOnServer(app) {
  var _app$wallet;
  if ((app === null || app === void 0 ? void 0 : app.BROWSER) != 0 || !(app !== null && app !== void 0 && (_app$wallet = app.wallet) !== null && _app$wallet !== void 0 && _app$wallet.disableProducingBlocksByTimer)) {
    return Promise.resolve();
  }
  logManualProduction('Disabling automatic timer production (test mode)');
  logManualProduction('wallet.disableProducingBlocksByTimer() started');
  return Promise.resolve(app.wallet.disableProducingBlocksByTimer()).then(function () {
    logManualProduction('wallet.disableProducingBlocksByTimer() completed');
  })["catch"](function (err) {
    logManualProductionError('disableTimerProductionOnServer', err);
    console.warn('Explorer: disableProducingBlocksByTimer failed', err);
  });
}

/**
 * Server-only: enter test mode when not already active.
 */
function enterExplorerTestMode(app, mod) {
  if ((app === null || app === void 0 ? void 0 : app.BROWSER) == 1 || !mod || mod.test_mode === true) {
    return;
  }
  mod.test_mode = true;
  logManualProduction('Entering test mode');
  disableTimerProductionOnServer(app);
}
function manualTestingDeniedMessage(app, mod) {
  if (!allowsManualTestingOnServer(app, mod)) {
    return 'Manual block production is disabled on this server.';
  }
  return 'Cannot enter Explorer test mode.';
}

/**
 * Server: permit manual simulation and enter test mode when needed.
 */
function ensureExplorerTestModeForManualAction(app, mod) {
  var _app$modules;
  var spamEnabled = Boolean(app === null || app === void 0 || (_app$modules = app.modules) === null || _app$modules === void 0 ? void 0 : _app$modules.returnModule('spam'));
  var nodeEnv = String(process.env.NODE_ENV || '(unset)');
  logManualProduction("ensureExplorerTestModeForManualAction: test_mode=".concat(Boolean(mod === null || mod === void 0 ? void 0 : mod.test_mode), ", ") + "enable_manual_testing=".concat(Boolean(mod === null || mod === void 0 ? void 0 : mod.enable_manual_testing), ", ") + "spam=".concat(spamEnabled, ", NODE_ENV=").concat(nodeEnv));
  if (!allowsManualTestingOnServer(app, mod)) {
    logManualProduction('Manual testing not permitted on this server');
    return {
      ok: false,
      error: manualTestingDeniedMessage(app, mod)
    };
  }
  if (!mod.test_mode) {
    logManualProduction('Not in test mode yet — entering test mode');
    enterExplorerTestMode(app, mod);
  } else {
    logManualProduction('Already in test mode');
  }
  return {
    ok: true
  };
}

/**
 * Prepare a manual block production request: test mode + starting block height.
 */
function beginManualBlockProduction(_x, _x2) {
  return _beginManualBlockProduction.apply(this, arguments);
}
function _beginManualBlockProduction() {
  _beginManualBlockProduction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app, mod) {
    var gate, startBlockId, _t, _t2, _t3;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          if (!((app === null || app === void 0 ? void 0 : app.BROWSER) == 1 || !mod)) {
            _context.n = 1;
            break;
          }
          return _context.a(2, {
            ok: false,
            error: 'Manual block production is server-only.'
          });
        case 1:
          _context.p = 1;
          gate = ensureExplorerTestModeForManualAction(app, mod);
          if (gate.ok) {
            _context.n = 2;
            break;
          }
          return _context.a(2, gate);
        case 2:
          _t2 = Number;
          _context.n = 3;
          return app.blockchain.getLatestBlockId();
        case 3:
          _t = _t2(_context.v);
          if (_t) {
            _context.n = 4;
            break;
          }
          _t = 0;
        case 4:
          startBlockId = _t;
          logManualProduction("beginManualBlockProduction: starting block id=".concat(startBlockId));
          return _context.a(2, {
            ok: true,
            startBlockId: startBlockId
          });
        case 5:
          _context.p = 5;
          _t3 = _context.v;
          logManualProductionError('beginManualBlockProduction', _t3);
          throw _t3;
        case 6:
          return _context.a(2);
      }
    }, _callee, null, [[1, 5]]);
  }));
  return _beginManualBlockProduction.apply(this, arguments);
}
function requestVariantLabel(requestType) {
  if (requestType === EXPLORER_PRODUCE_BLOCK_WITH_GT_REQUEST) {
    return 'GT';
  }
  if (requestType === EXPLORER_PRODUCE_BLOCK_REQUEST) {
    return 'non-GT';
  }
  return requestType || 'unknown';
}
function normalizeManualProductionResult(result) {
  if (result === true) {
    return {
      blockProduced: true
    };
  }
  if (result === false || result == null) {
    return {
      blockProduced: false
    };
  }
  if (_typeof(result) === 'object' && result.blockProduced) {
    return result;
  }
  return {
    blockProduced: false
  };
}

/**
 * Server produce request: test mode, wallet produce helper, callback when done.
 */
function runManualBlockProductionRequest(_x3, _x4, _x5, _x6) {
  return _runManualBlockProductionRequest.apply(this, arguments);
}
function _runManualBlockProductionRequest() {
  _runManualBlockProductionRequest = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(app, mod, produceExplorerBlock, mycallback) {
    var requestType,
      variant,
      begin,
      production,
      payload,
      latestBlockId,
      reason,
      _args2 = arguments,
      _t4,
      _t5,
      _t6;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          requestType = _args2.length > 4 && _args2[4] !== undefined ? _args2[4] : '';
          variant = requestVariantLabel(requestType);
          logManualProduction("runManualBlockProductionRequest entered (variant=".concat(variant, ")"));
          _context2.p = 1;
          _context2.n = 2;
          return beginManualBlockProduction(app, mod);
        case 2:
          begin = _context2.v;
          if (begin.ok) {
            _context2.n = 3;
            break;
          }
          logManualProduction("FAILURE callback: ".concat(begin.error));
          if (mycallback) {
            mycallback(failure(begin.error));
          }
          return _context2.a(2);
        case 3:
          logManualProduction("runManualBlockProductionRequest: startBlockId=".concat(begin.startBlockId, ", variant=").concat(variant));
          _t4 = normalizeManualProductionResult;
          _context2.n = 4;
          return produceExplorerBlock(app, mod, begin.startBlockId);
        case 4:
          production = _t4(_context2.v);
          if (!production.blockProduced) {
            _context2.n = 5;
            break;
          }
          payload = {
            blockProduced: true
          };
          if (production.verificationWarning) {
            payload.verificationWarning = production.verificationWarning;
            logManualProduction("SUCCESS callback: block produced (start=".concat(begin.startBlockId, "), ") + "verification warning=".concat(production.verificationWarning));
          } else {
            logManualProduction("SUCCESS callback: block produced (start=".concat(begin.startBlockId, ")"));
          }
          if (mycallback) {
            mycallback(success(payload));
          }
          return _context2.a(2);
        case 5:
          _t5 = Number;
          _context2.n = 6;
          return app.blockchain.getLatestBlockId();
        case 6:
          latestBlockId = _t5(_context2.v);
          reason = 'Block production timed out.';
          logManualProduction("FAILURE callback: ".concat(reason, " (current=").concat(latestBlockId, ", start=").concat(begin.startBlockId, ")"));
          if (mycallback) {
            mycallback(failure(reason));
          }
          _context2.n = 8;
          break;
        case 7:
          _context2.p = 7;
          _t6 = _context2.v;
          logManualProductionError('runManualBlockProductionRequest', _t6);
          console.error('Explorer: manual block production failed on server', _t6);
          logManualProduction("FAILURE callback: ".concat((_t6 === null || _t6 === void 0 ? void 0 : _t6.message) || 'Block production failed.'));
          if (mycallback) {
            mycallback(failure((_t6 === null || _t6 === void 0 ? void 0 : _t6.message) || 'Block production failed.'));
          }
        case 8:
          return _context2.a(2);
      }
    }, _callee2, null, [[1, 7]]);
  }));
  return _runManualBlockProductionRequest.apply(this, arguments);
}
module.exports = {
  enterExplorerTestMode: enterExplorerTestMode,
  ensureExplorerTestModeForManualAction: ensureExplorerTestModeForManualAction,
  beginManualBlockProduction: beginManualBlockProduction,
  runManualBlockProductionRequest: runManualBlockProductionRequest,
  manualTestingDeniedMessage: manualTestingDeniedMessage
};